import { render, staticRenderFns } from "./associationDetail.vue?vue&type=template&id=5653372f&scoped=true&"
import script from "./associationDetail.vue?vue&type=script&lang=js&"
export * from "./associationDetail.vue?vue&type=script&lang=js&"
import style0 from "./associationDetail.vue?vue&type=style&index=0&id=5653372f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5653372f",
  null
  
)

export default component.exports